// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__ymWF3","portfolioContainer":"Portfolio_portfolioContainer__MBQg7","portfolioWrapper":"Portfolio_portfolioWrapper__7NaVi"};